module.exports = __webpack_public_path__ + "img/H5.af761526.png";